import React from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import PilotBanner from "@/modules/racket_lab_admin/PilotBanner";
import RLNavSidebar from "@/modules/racket_lab_admin/RLNavSidebar";
import DispatchStatusBanner from "@/modules/racket_lab_admin/DispatchStatusBanner";
import RetentionPurgeForm from "@/modules/racket_lab_admin/RetentionPurgeForm";
import { useRacketLabAdminT } from "@/i18n/racketLabAdminI18n";

const RLAdminOpsRetention = () => {
  const t = useRacketLabAdminT();
  return (
    <div data-testid="rl-admin-ops-retention-page" className="flex flex-col gap-4">
      <PilotBanner />
      <RLNavSidebar />
      <DispatchStatusBanner />
      <Link to="/admin/racket-lab/ops" data-testid="rl-ops-retention-back" className="inline-flex w-fit items-center gap-1 text-xs text-slate-600 hover:text-slate-900"><ArrowLeft className="w-3.5 h-3.5" /> {t("ops.common.back_to_toolkit")}</Link>
      <header>
        <h1 className="text-xl font-semibold text-slate-900">{t("ops.retention.page_title")}</h1>
        <p className="text-xs text-slate-500">
          {/* Splits the subtitle around the {strong} placeholder so the
              "NOT reversible" segment renders with the rose-700 emphasis
              while the surrounding copy stays translatable. */}
          {(() => {
            const tpl = t("ops.retention.page_subtitle_html");
            const parts = tpl.split("{strong}");
            return (
              <>
                {parts[0]}
                <strong className="text-rose-700">{t("ops.retention.not_reversible")}</strong>
                {parts[1] || ""}
              </>
            );
          })()}
        </p>
      </header>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <RetentionPurgeForm kind="qr_pre_lookup_denials" />
        <RetentionPurgeForm kind="mock_outbox" />
      </div>
    </div>
  );
};

export default RLAdminOpsRetention;
